import eth from './eth.svg'
import susdc from './susdc.svg'
import susds from './susds.svg'
import unichain from './unichain.svg'
import usdc from './usdc.svg'
import usds from './usds.svg'

export const tokenLogos = {
  eth,
  usdc,
  usds,
  susds,
  susdc,
}

export const chainLogo = unichain
